import { render } from "./presets.vue?vue&type=template&id=ba154f64&scoped=true"
import script from "./presets.vue?vue&type=script&lang=js"
export * from "./presets.vue?vue&type=script&lang=js"

import "./presets.vue?vue&type=style&index=0&id=ba154f64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kenyo\\Documents\\dev\\passwords\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba154f64"]])

export default __exports__